import type { IconProps } from '../types/IconProps.ts';
export const ArrowUpToLine: IconProps = {
    name: 'ArrowUpToLine',
    children: [
        `<path d="m5 13 5.65-5.85c.2-.2.5-.2.7 0L17 13M11 8v13.2M5 3h14" />`,
    ]
};